import { twMerge } from "tailwind-merge";
import type { IconProps } from "./types";

export const TagNumber = ({ size, color, className, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={twMerge(color == null && "h-5 w-5 stroke-current", className)}
    stroke={color}
    fill="none"
    {...props}
  >
    <path
      d="M2.05526 10.6385C2 10.4083 2 10.1637 2 9.67452L2 6.82548C2 6.3363 2 6.09171 2.05526 5.86154C2.10425 5.65746 2.18506 5.46237 2.29472 5.28343C2.4184 5.0816 2.59136 4.90864 2.93726 4.56274L4.56274 2.93726C4.90865 2.59135 5.0816 2.4184 5.28343 2.29472C5.46237 2.18506 5.65746 2.10425 5.86154 2.05526C6.09171 2 6.3363 2 6.82548 2L9.67452 2C10.1637 2 10.4083 2 10.6385 2.05526C10.8425 2.10425 11.0376 2.18506 11.2166 2.29472C11.4184 2.4184 11.5914 2.59136 11.9373 2.93726L19.6059 10.6059C20.7939 11.7939 21.388 12.388 21.6105 13.0729C21.8063 13.6755 21.8063 14.3245 21.6105 14.927C21.388 15.612 20.7939 16.2061 19.6059 17.3941L17.3941 19.6059C17.0524 19.9476 15.7598 21.2513 15.5 21.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33325 14.6667H12.6666M3.33325 19.3333H12.6666M5.66659 11.75V22.25M10.3333 11.75V22.25"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
